import React, {useEffect} from 'react'

import {useAppDispatch} from '../../../../../hooks/react-redux'
import Loader from '../../../../common/Loader/Loader'
import {usePipelineId} from '../../hooks/pipeline'
import {useEditPipelineYAML} from '../EditPipelinePage.hooks'
import {pipelineYaml} from '../slices/EditPipelinePage.slices'

import styles from './EditPipelineYAML.css'

const YamlEditor = React.lazy(
  () =>
    import(
      /* webpackChunkName: "YamlEditor", webpackPrefetch: true */
      './YamlEditor/YamlEditor'
    ),
)

export function EditPipelineYAML() {
  const pipelineId = usePipelineId()
  const dispatch = useAppDispatch()
  const {yaml, yamlEditorValidateHandler, yamlEditorChangeHandler} = useEditPipelineYAML()

  useEffect(
    () => () => {
      dispatch(pipelineYaml.actions.reset(pipelineId))
    },
    [dispatch, pipelineId],
  )

  return (
    <div className={styles.main}>
      {yaml != null && (
        <React.Suspense fallback={<Loader data-suspense-fallback />}>
          <YamlEditor
            onChange={yamlEditorChangeHandler}
            onValidate={yamlEditorValidateHandler}
            value={yaml}
          />
        </React.Suspense>
      )}
    </div>
  )
}
